import { Scrollbar } from 'react-scrollbars-custom'
import ChallengeSection from '../section/ChallengeSection'
import { useChallengeQuests } from '../../model/hooks/useChallengeQuests'

export default function ChallengesList() {
  const challengesQuests = useChallengeQuests()
  const listKey = challengesQuests
    ?.map(({ id, isComplete, isCollected }) => `${id}:${isComplete}:${isCollected}`)
    .join('|')

  return (
    <div className={'challenges__block'}>
      <Scrollbar key={listKey}>
        <div className={'challenges__list'}>
          {challengesQuests?.map((challengeData, index) => (
            <ChallengeSection
              key={challengeData.id ?? index}
              challengeData={challengeData}
            />
          ))}
        </div>
      </Scrollbar>
    </div>
  )
}
